import { useEffect, useState } from "react";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import moment from 'jalali-moment';
import { numberWithCommas } from "src/utils/thousandSeprator";
import { RxExternalLink } from "react-icons/rx";
import MiniInfoButton from "src/components/MiniInfoButton";
import InputBox from "./components/InputBox";
import { getData } from "src/actions/getData";
import { get, post, put } from "src/services/HttpClient/HttpClient";
import Loading from "src/components/Loading";
import { notify } from "src/services/Notification/Notification";
import Hintbox from "src/components/Hintbox";

export default function SellerProducts() {

  // const { products, setProducts } = useContext(shopContext)
  const [products, setProducts] = useState()
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    const controller = new AbortController(); // برای لغو درخواست
    const signal = controller.signal;

    getData((products) => {
      // const blockedBrands = [
      //   "شیگلم", "لورال", "مارتینا",
      //   "گابرینی Gabrini", "لویتون", "بیوکسین", "اوردینری", "کلینیک",
      //   "لیزا", "دیور", "رولون", "بل", "میرادور", "وازلین",
      //   "رکسونا", "تن فوراور", "یورن", "مارکویز", "فلورمار",
      //   "داو", "فارماسی", "اسنس", "سینت ایوز", "اسکارلت",
      //   "نیوآ", "میبلین",
      //   "سریس", "گارنیر", "مورلی", "بیو", "ریمل", "مون بلان",
      //   "فوراور لیوینگ", "اورال بی", "نوتروژینا",
      //   "توکوبو", "سنتلا",
      //   "باباریا", "مورفوس", "دوسه", "بایودرما", "فینو Fino",
      //   "منهتن", "بورژوا", "سام بای می", "ای سی ام",
      //   "اکسیس وای", "لاروش پوزای", "شیسیدو", "بیوتی آف جوسان",
      //   "کوزارکس", "ایزدین", "گلدن رز",
      //   "اون", "8X4", "کلیون CLIVEN", "اولد اسپایس Old Spice",
      //   "اکس Axe",
      //   "سوییت بیوتی", "یانگمی Yangmei", "بایوآکوا", "مارویس marvis",
      //   "کلیر clear", "گلیس Gliss", "پنتن pantene",
      //   "هنگ فنگ Heng Fang", "زد وان Z.one", "دکتر مورنینگ Dr Morning",
      //   "کالر کاستل color castle", "مکس فاکتور Max factor", "آگاوه Agave", "دنی وان",
      //   "دان بیوتی", "سیمپل", "ایزادورا",
      //   "لویس آلاویا", "افنان", "آنوا",
      //   "فارم استی", "مدی کیوب", "تی جی", "کلارنس", "آلپسین", "استی لادر",
      //   "بالانس", "کالر اکسپرت", "تروکاور",
      //   "لانبنا", "اتود"
      // ];

      const blockedBrands = []

      const filteredProducts = products.filter(
        product => !blockedBrands.includes(product.brand?.trim())
      );

      setProducts(filteredProducts);
    }, "/sellers/products?limit=10000", {}, signal);

    return () => {
      controller.abort();
    };
  }, [])

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    setIsUploading(true)
    e.preventDefault();
    if (!file) {
      alert("Please select a file first!");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    try {
      let response = await post("/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setIsUploading(false)
      setUploadStatus(response?.success);
      if (response?.success) {
        notify(response?.message)
        let result = await get(`product/queue/update/${file.name}`)
        notify(result?.message)
      } else {
        notify(response?.message, "error")
      }

    } catch (err) {
      notify("خطا شبکه، لطفا یکبار صفحه را رفرش کنید و مجددا امتحان کنید", "error")
      setIsUploading(false)
      setUploadStatus(false);
    }
  };

  const columns = [
    {
      id: "featuredImage",
      cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${info.row.original.id}/${info.getValue()}`} />),
      header: "تصویر",
      inExport: false
    },
    {
      id: "id",
      cell: (info) => info.getValue(),
      header: "شناسه",
      inTable: true,
      inExport: false,
    },
    {
      id: "id",
      cell: (info) => info.getValue(),
      header: "id",
      inTable: false,
      inExport: true,
    },
    {
      id: "name",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "نام محصول",
    },
    {
      id: "sku",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "sku",
    },
    {
      id: "brand",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "برند",
    },
    {
      id: "price",
      cell: (info) => <div className="flex gap-1 items-center justify-center">
        <InputBox
          defaultValue={numberWithCommas(info.getValue())}
          handleClick={async (value) => {
            await put("products/" + info.row.original.id, {
              "price": value
            })
          }}
        />تومان</div>,
      header: "قیمت مصرف کننده",
      inTable: true,
      inExport: false,
    },
    {
      id: "price",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "price",
      inTable: false,
      inExport: true,
    },
    {
      id: "salePrice",
      cell: (info) => <div className="flex gap-1 items-center justify-center">
        <InputBox
          defaultValue={numberWithCommas(info.getValue())}
          handleClick={async (value) => {
            await put("products/" + info.row.original.id, {
              "salePrice": value
            })
          }}
        />تومان</div>,
      header: "قیمت فروش ویژه",
      inExport: false
    },
    {
      id: "salePrice",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "salePrice",
      inTable: false,
      inExport: true,
    },
    {
      id: "stockQuantity",
      cell: (info) => <InputBox
        isMinify
        defaultValue={info.getValue()}
        handleClick={async (value) => {
          await put("products/" + info.row.original.id, {
            "stockQuantity": value
          })
        }}
        type="number"
      />,
      header: "موجودی",
      inExport: false
    },
    {
      id: "stockQuantity",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "stockQuantity",
      inTable: false,
      inExport: true,
    },
    {
      id: "status",
      cell: (info) => info.getValue() ? info.getValue() : "---",
      header: "وضعیت انتشار",
      inExport: false,
      inTable: true
    },
    {
      id: "slug",
      cell: (info) => (
        <div className="flex gap-2">
          <a
            title="لینک محصول"
            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
            target="_blank"
            href={process.env.REACT_APP_SITE_URL + '/product/' + info.getValue()}
          >
            <RxExternalLink className="text-blue-500" />
          </a>
        </div>
      ),
      header: "آدرس",
      footer: (info) => info.column.id,
      enableColumnFilter: false,
      inExport: false,
    },
  ];

  return (
    <>
      <PageHeader
        title="لیست محصولات"
      >
        {/* <div className="flex justify-between gap-2 items-center bg-gray-200 border border-gray-300 rounded-xl p-1 text-sm">

          <span>بروزرسانی با اکسل</span>
          {
            !file
              ?
              <>
                <input type="file" id="file" className="custom-file-input rounded-lg hidden" accept=".csv,.xlsx" onChange={handleFileChange} />
                <label for="file" className="cursor-pointer flex flex-col gap-1 justify-center items-center bg-blue-500 text-white p-2 py-3 rounded-xl">
                  انتخاب فایل
                </label>
              </>
              :
              <button
                className="flex flex-col gap-1 justify-center items-center bg-blue-500 text-white p-2 py-3 rounded-xl"
                onClick={async (e) => {
                  handleUpload(e);
                }}>
                شروع بارگذاری
              </button>
          }

        </div> */}
      </PageHeader>
      {/* <Loading title="در حال انجام تغییرات ..." /> */}
      <Hintbox text="در هنگام بروزرسانی محصولات از طریق پنل یا بارگذاری فایل اکسل حتما به این نکته دقت کنید که محصولات شما باید هم قیمت و هم موجودی به صورت همزمان داشته باشند. محصولاتی که تنها موجودی یا قیمت خورده اند در سایت نمایش داده نخواهند شد." type="error" />
      <Table
        columns={columns}
        data={products}
        // requestPath={`/seller/products`}
        // setRequestData={setProducts}
        // isLiveGlobalSearch={false}
        // isBackendGlobalSearch={true}
        CSVExportPermission="viewDashboard"
        tableName="products"
      />
    </>
  )

}
